import { useEffect, useMemo, useState } from "react";
import { Box, Stack, TextField, Button, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";


import BreadcrumbsBar from "../../../../../component/common/BreadcrumbsBar";
import ReportContainer from "../../../component/ReportContainer";
import ReportHeader from "../../../component/ReportHeader";
import ReportToolbar from "../../../component/ReportToolbar";
import ReportTitle from "../../../component/ReportTitle";
import ReportActions from "../../../component/ReportActions";
import ReportLoading from "../../../component/ReportLoading";
import ReportNoData from "../../../component/ReportNoData";
import { MenuItem } from "@mui/material";
import WGRViewer from "./lslViewer";
import { getLSL } from "../../../../../services/reportService";
import generateWGRPDF from "./pdfreport/generatelslPDF";

import { useLocation } from "react-router-dom";

import SearchIcon from "@mui/icons-material/Search";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function LabourLedgerPage() {





  const location = useLocation();

  const report = location.state || {
    reportType: "WGR",
    title: "WORKSHOP GENERAL REGISTER",
  };

  const { reportType, title } = report;

  const today = new Date();



  const month = location.state.month;
  const year = location.state.year;




  const [rows, setRows] = useState([]);

  const [loading, setLoading] = useState(false);

  const monthName = useMemo(
    () => months[month - 1],
    [month]
  );

  const loadReport = async () => {
    try {
      setLoading(true);

      const res = await getLSL(month, year);

      setRows(res.data.data || []);






    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    loadReport();
  };

  const handlePrint = () => {
    window.print();

    setTimeout(() => {
      setRows([]);
    }, 500);
  };



  /*
     * Grand Total
     */
  const grandTotal = useMemo(() => {
    return rows.reduce(
      (total, row) => ({
        highlyskilledtime:
          total.highlyskilledtime +
          Number(row.HIGHLYSKILLEDTIME || 0),

        highlyskilledcost:
          total.highlyskilledcost +
          Number(row.HIGHLYSKILLEDCOST || 0),

        skilledtime:
          total.skilledtime +
          Number(row.SKILLEDTIME || 0),

        skilledcost:
          total.skilledcost +
          Number(row.SKILLEDCOST || 0),


        semiskilledtime:
          total.semiskilledtime +
          Number(row.SEMISKILLEDTIME || 0),

        semiskilledcost:
          total.semiskilledcost +
          Number(row.SEMISKILLEDCOST || 0),

        unskilledtime:
          total.unskilledtime +
          Number(row.UNSKILLEDTIME || 0),

        unskilledcost:
          total.unskilledcost +
          Number(row.UNSKILLEDCOST || 0),

        oncostlabour:
          total.oncostlabour +
          Number(row.ONCOSTLABOUR || 0),

        oncoststore:
          total.oncoststore +
          Number(row.ONCOSTSTORE || 0),








      }),










      {
        highlyskilledtime: 0,
        highlyskilledcost: 0,
        skilledtime: 0,
        skilledcost: 0,
        semiskilledtime: 0,
        semiskilledcost: 0,
        unskilledtime: 0,
        unskilledcost: 0,
        oncostlabour: 0,
        oncoststore: 0,
      }
    );
  }, [rows]);





  // const summary = useMemo(() => {
  //   let ds8 = 0;
  //   let minDs8 = 0;
  //   let mDr = 0;
  //   let mfgdRet = 0;
  //   let minusMfgdRet = 0;

  //   rows.forEach((row) => {
  //     const misc = String(row.PRIMECOST_MISC || "").trim().toUpperCase();
  //     const amount = Number(row.PRIMECOST_STORES || 0);

  //     switch (misc) {
  //       case "DS8":
  //         ds8 += amount;
  //         break;

  //       case "MIN DS8":
  //         minDs8 += amount;
  //         break;

  //       case "M-DR":
  //         mDr += amount;
  //         break;

  //       case "MFGD RET.":
  //         mfgdRet += amount;
  //         break;

  //       case "MINUS MFGD RET.":
  //         minusMfgdRet += amount;
  //         break;

  //       default:
  //         break;
  //     }
  //   });

  //   return {
  //     ds8: (-1 * ds8),
  //     minDs8,
  //     mDr: (-1 * mDr),
  //     mfgdRet,
  //     minusMfgdRet,
  //     directStore:
  //       grandTotal.primeStores - ds8 - minDs8 - mDr,

  //     returnedStore:
  //       (-1 * (ds8 + minDs8)),
  //   };
  // }, [rows, grandTotal]);






  const handlePdf = () => {
    generateWGRPDF(
      reportType,
      title,
      grandTotal,
      rows,
      "",
      monthName,

      year
    );
  };

  const handleExcel = () => {
    console.log("Generate Excel");
  };


  useEffect(() => {
    // Optional: Clear previous report
    setRows([]);

    // Load report if you want automatically
    loadReport();

  }, [reportType]);




  return (
    <Box >

      <BreadcrumbsBar page={title} />


      {/* Search Panel */}




      {/* Report */}

      <ReportContainer>


        <ReportToolbar>

          <ReportTitle
            title={title}
            subtitle={`${monthName} ${year}`}
          />

          <Box className="no-print">
            <ReportActions
              onRefresh={handleRefresh}
              onPrint={handlePrint}
              onPdf={handlePdf}
              onExcel={handleExcel}
            />
          </Box>



        </ReportToolbar>

        {loading ? (
          <ReportLoading />
        ) : rows.length === 0 ? (
          <ReportNoData text="Click Generate to view report." />
        ) : (
          <WGRViewer
            rows={rows}
            grandTotal={grandTotal}
            summary=""
          />
        )}

      </ReportContainer>

    </Box>
  );
}